export enum AccountSettingsPopupType {
  PhoneNumber = 'Phone Number',
  EmailAddress = 'Email Address',
  Password = 'Password',
}
